import { passwordValidationRules, emailValidationRules } from 'utils';
import { useState } from 'react';

export const useValidatePassword = () => {
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState<
    string | null
  >(null);
  const [emailError, setEmailError] = useState<string | null>(null);

  const validatePassword = (
    password: string,
    confirmPassword: string,
    email?: string,
    emailRequired?: boolean
  ): boolean => {
    if (emailRequired && !emailValidationRules.test(email || '')) {
      setEmailError('Invalid email');
      return false;
    }

    if (password !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match');
      return false;
    } else {
      setConfirmPasswordError(null);
    }

    if (!passwordValidationRules.test(password)) {
      setPasswordError(
        'Password must contain at least 8 characters, including uppercase, lowercase, and numbers'
      );
      return false;
    } else {
      setPasswordError(null);
    }
    return true;
  };
  return { passwordError, confirmPasswordError, emailError, validatePassword };
};
